import { StorageBackend } from './index'

export class NoStorageBackend implements StorageBackend {
  public get(key: string): any {}

  public set(key: string, value: any): void {}

  public remove(key: string): void {}

  public clear() {}
}

export class MemoryStorageBackend implements StorageBackend {
  private store: any = {}

  public get(key: string): any {
    return this.store[key]
  }

  public set(key: string, value: any): void {
    this.store[key] = value
  }

  public remove(key: string): void {
    delete this.store[key]
  }

  public clear() {
    this.store = {}
  }
}
